import { useMutation } from 'react-query';
import {
  createDefenseBridgeAsync,
  deleteDefenseBridgeAsync,
  downloadEventTypesExcelFileAsync,
  downloadSourceEventTypesExcelFileAsync,
  getDefenseBridgeAsync,
  getDefenseBridgeByLicenseAsync,
  updateDefenseBridgeAsync,
} from '../../index';

export const useCreateDefenseBridgeAsync = () =>
  useMutation(createDefenseBridgeAsync);

export const useUpdateDefenseBridgeAsync = () =>
  useMutation(updateDefenseBridgeAsync);

export const useDeleteDefenseBridgeAsync = () =>
  useMutation(deleteDefenseBridgeAsync);
export const useGetDefenseBridgeAsync = () =>
  useMutation(getDefenseBridgeAsync);

export const useGetDefenseBridgeByLicenseAsync = () =>
  useMutation(getDefenseBridgeByLicenseAsync);

export const useDownloadEventTypesExcelFileAsync = () =>
  useMutation(downloadEventTypesExcelFileAsync);

export const useDownloadSourceEventTypesExcelFileAsync = () =>
  useMutation(downloadSourceEventTypesExcelFileAsync);
